export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Luxurious%20artistic%20flat%20lay%20arrangement%20of%20premium%20fashion%20accessories%20including%20a%20vintage%20gold%20tone%20chronograph%20watch%20with%20brown%20leather%20strap%2C%20black%20leather%20cardholder%20wallet%2C%20circular%20tortoiseshell%20sunglasses%20with%20warm%20amber%20tint%2C%20copper%20pen%2C%20and%20textured%20linen%20notebook%20scattered%20organically%20across%20warm%20sand%20colored%20marble%20surface%2C%20soft%20directional%20morning%20light%20casting%20gentle%20elongated%20shadows%2C%20editorial%20lifestyle%20aesthetic%20with%20rich%20warm%20terracotta%20and%20cream%20palette%2C%20high%20detail%20professional%20product%20photography%2C%20elegant%20composition%20with%20intentional%20negative%20space&width=1800&height=1000&seq=hero-main-v2-20260712&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/50 to-white/85"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16 md:pt-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100/70 rounded-full mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs font-semibold text-accent-700 tracking-wide">Updated July 2026</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-foreground-950 leading-tight tracking-tight mb-5">
          Hipobuy Spreadsheet
        </h1>
        <p className="font-heading text-xl md:text-2xl lg:text-3xl italic text-foreground-700 mb-4">
          The Ultimate Shopping Resource
        </p>
        <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto mb-10 leading-relaxed">
          Discover organized product lists, category guides, comparison tools and expert resources designed to help shoppers find products faster and make better decisions.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all hover:scale-[1.02] whitespace-nowrap"
          >
            Hipobuy Sheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-transparent text-foreground-800 border-2 border-foreground-300 rounded-full text-base font-semibold hover:border-foreground-500 hover:text-foreground-950 transition-all hover:scale-[1.02] whitespace-nowrap"
          >
            Buy It Now
            <i className="ri-shopping-bag-line"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10 text-xs text-foreground-400">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500 text-sm"></i> Updated Resources
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500 text-sm"></i> Organized Categories
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500 text-sm"></i> Shopping Guides
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500 text-sm"></i> Safety Information
          </span>
        </div>

        <div className="mt-16">
          <a
            href="#categories"
            className="inline-flex items-center gap-1 text-sm text-foreground-400 hover:text-foreground-700 transition-colors"
          >
            Explore Categories
            <i className="ri-arrow-down-line animate-bounce"></i>
          </a>
        </div>
      </div>
    </section>
  );
}